export default {
  currentCall: 'Current Call',
  viewCalls: 'View Calls',
  view: 'View',
  incomingCall: '{numberOf} Incoming Call',
  incomingCalls: '{numberOf} Incoming Calls',
  callOnHold: '{numberOf} Call On Hold',
  callsOnHold: '{numberOf} Calls On Hold',
  otherDeviceCall: '{numberOf} Call on other devices',
  otherDeviceCalls: '{numberOf} Calls on other devices',
} as const;
